import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "font-bold"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "mt-4"
};
const _hoisted_4 = {
  class: "rounded-lg border-0 relative"
};
import { computed, reactive } from 'vue';
import LlRadioGroup from '@/components/LlRadioGroup.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTextField from '@/components/LlTextField.vue';
import { useMaxioSubscriptionStore } from './useMaxioSubscriptionStore.js';
export default {
  __name: 'CancelSubscriptionModal',
  props: {
    alerts: {
      type: Object,
      required: false
    },
    subscription: {
      type: Object,
      required: true
    }
  },
  emits: ['close'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const cancelSubscriptionState = reactive({
      openDialog: true,
      loading: false,
      cancellationReasons: [{
        text: 'Too expensive',
        showInput: false
      }, {
        text: 'Switching to another tool',
        showInput: true
      }, {
        text: 'Missing features',
        showInput: false
      }, {
        text: 'Closing the firm',
        showInput: false
      }, {
        text: 'Other',
        showInput: true
      }],
      selectedReason: null,
      customReason: ''
    });
    const reasonOptions = computed(() => cancelSubscriptionState.cancellationReasons.map(({
      text
    }) => ({
      label: text,
      value: text
    })));
    const selectedReasonNeedsDetail = computed(() => cancelSubscriptionState.cancellationReasons.find(({
      text
    }) => text === cancelSubscriptionState.selectedReason)?.showInput ?? false);
    const emit = __emit;
    const maxioCompanySubscriptionStore = useMaxioSubscriptionStore();
    maxioCompanySubscriptionStore.alerts = props.alerts;
    const cancelSubscription = async () => {
      cancelSubscriptionState.loading = true;
      try {
        await maxioCompanySubscriptionStore.cancelSubscription(cancelSubscriptionState.selectedReason, cancelSubscriptionState.customReason);
        cancelSubscriptionState.openDialog = false;
        emit('close');
      } catch (error) {
        console.error('Error cancelling subscription:', error);
        maxioCompanySubscriptionStore.alerts.error('Failed to cancel subscription. Please try again later.');
      } finally {
        cancelSubscriptionState.loading = false;
      }
    };
    const cancel = () => {
      cancelSubscriptionState.openDialog = false;
      emit('close');
    };
    return (_ctx, _cache) => {
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_divider = _resolveComponent("v-divider");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_dialog, {
        modelValue: cancelSubscriptionState.openDialog,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => cancelSubscriptionState.openDialog = $event),
        persistent: "",
        "max-width": "500px"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, {
          title: "Cancel Subscription",
          density: "compact"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [_createElementVNode("label", _hoisted_1, [_cache[3] || (_cache[3] = _createTextVNode(" Your subscription will remain active until the end of your current billing period ", -1)), __props.subscription.plan?.periodEnd ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (" + _toDisplayString(_ctx.formatDate(__props.subscription.plan?.periodEnd)) + ") ", 1)) : _createCommentVNode("", true), _cache[4] || (_cache[4] = _createTextVNode(" . You will not be billed again after that date. ", -1))]), _createElementVNode("div", _hoisted_3, [_createVNode(LlRadioGroup, {
              modelValue: cancelSubscriptionState.selectedReason,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => cancelSubscriptionState.selectedReason = $event),
              label: "Why are you cancelling? (optional)",
              options: reasonOptions.value,
              inline: false
            }, null, 8, ["modelValue", "options"]), selectedReasonNeedsDetail.value ? (_openBlock(), _createBlock(LlTextField, {
              key: 0,
              modelValue: cancelSubscriptionState.customReason,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => cancelSubscriptionState.customReason = $event),
              placeholder: "Please specify",
              "aria-label": "Tell us more about why you are cancelling",
              class: "mt-2"
            }, null, 8, ["modelValue"])) : _createCommentVNode("", true)])]),
            _: 1
          }), _createVNode(_component_v_divider), _createVNode(_component_v_card_actions, {
            class: "justify-end"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_v_card_actions, {
              class: "justify-end"
            }, {
              default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                class: "mr-4",
                onClick: cancel
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("Close", -1)]))]),
                _: 1
              }), _createVNode(LlSecondaryButton, {
                color: "primary",
                disabled: cancelSubscriptionState.loading,
                onClick: cancelSubscription
              }, {
                default: _withCtx(() => [_withDirectives(_createElementVNode("span", null, "Confirm Cancellation", 512), [[_vShow, !cancelSubscriptionState.loading]]), _withDirectives(_createElementVNode("span", null, [...(_cache[6] || (_cache[6] = [_createElementVNode("span", {
                  class: "fa fa-cog fa-spin"
                }, null, -1), _createTextVNode(" Cancelling... ", -1)]))], 512), [[_vShow, cancelSubscriptionState.loading]])]),
                _: 1
              }, 8, ["disabled"])]),
              _: 1
            })])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};